import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImageAnimated from '../../ItemImageAnimated'
import image from '../../../assets/images/bedroom/item--window@3x.png'
import Frame1Image from '../../../assets/images/bedroom/item--window--f1@3x.png'
import Frame2Image from '../../../assets/images/bedroom/item--window--f2@3x.png'
import Frame3Image from '../../../assets/images/bedroom/item--window--f3@3x.png'
import Frame4Image from '../../../assets/images/bedroom/item--window--f4@3x.png'
import Frame5Image from '../../../assets/images/bedroom/item--window--f5@3x.png'
import Frame6Image from '../../../assets/images/bedroom/item--window--f6@3x.png'
import Frame7Image from '../../../assets/images/bedroom/item--window--f7@3x.png'
import Frame8Image from '../../../assets/images/bedroom/item--window--f8@3x.png'

const frames = [
  Frame7Image,
  Frame6Image,
  Frame5Image,
  Frame4Image,
  Frame3Image,
  Frame2Image,
  Frame1Image,
  Frame1Image,
  Frame1Image,
  Frame1Image,
  Frame2Image,
  Frame3Image,
  Frame4Image,
  Frame5Image,
  Frame6Image,
  Frame7Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
  Frame8Image,
]

const points =
  '139.43 0 0 80.5 0 181.12 1.76 182.14 141.19 101.64 141.19 1.02 139.43 0'

const Window = ({ animate, ...props }) => (
  <IrregularInteraction
    points={points}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 166.73 182.14"
    sparksTop={6}
    sparksLeft={-27}
    sparksRotation={161}
    {...props}
  >
    <ItemImageAnimated
      unanimatedSrc={Frame8Image}
      srcs={frames}
      fps={10}
      animate={animate}
    />
  </IrregularInteraction>
)

Window.propTypes = IrregularInteraction.propTypes

export default Window



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Window.js